'use client'

import { useCheckout, useModals, usePaymentMethodDiscount } from '@/lib/hooks'
import type React from 'react'
import { useState } from 'react'

import { PaymentCard } from '@/components/molecules'
import { InputForm, ScrollArea } from '@/components/ui'

interface SelectPaymentCardTypeProps
  extends React.ComponentPropsWithoutRef<'form'> {
  onClose?: () => void
}

export const SelectPaymentCardType = ({
  onClose,
}: SelectPaymentCardTypeProps) => {
  const { setPaymentMethod, payment_methods, setCurrentStep, queryParams } =
    useCheckout()
  const { openModal } = useModals()
  const { applyPaymentMethodDiscount } = usePaymentMethodDiscount()
  const [isApplyingDiscount, setIsApplyingDiscount] = useState(false)

  const handleSubmit = (_data: FormData) => {}

  const handleOnSelect = async (method: any) => {
    setPaymentMethod(method)

    if (method?.last_digits_required) {
      // Don't apply discount yet - will be applied after verification
      openModal('PAYMENT_CARD_VERIFICATION')
    } else {
      if (queryParams?.cartId && method?.id) {
        setIsApplyingDiscount(true)
        try {
          await applyPaymentMethodDiscount({
            cartId: queryParams.cartId,
            paymentMethodId: method.id,
          })
        } catch (error) {
          console.error('Failed to apply/remove discount:', error)
          // Continue even if discount operation fails
        } finally {
          setIsApplyingDiscount(false)
        }
      }

      onClose?.()
      setCurrentStep('COLLECT_PAYMENT')
    }
  }

  return (
    <form
      className="flex min-h-[280px] w-full flex-col gap-4 lg:flex-wrap"
      action={handleSubmit}
    >
      <ScrollArea className="w-full lg:max-h-[264px]">
        <div className="flex w-full flex-col gap-2">
          {payment_methods?.card?.map((card: any, index: number) => {
            return (
              <PaymentCard
                key={index}
                card={card}
                shortcut={index + 1}
                onClick={() => !isApplyingDiscount && handleOnSelect(card)}
                className={
                  isApplyingDiscount
                    ? 'pointer-events-none opacity-50'
                    : undefined
                }
              />
            )
          })}
        </div>
      </ScrollArea>
    </form>
  )
}
